import React from "react";
import { RouteComponentProps } from "react-router";

import UserFormScreen from "./UserFormScreen";
import useGetUser from "../hooks/useGetUser";
import { EmptyState, Link, ScreenContainer } from "../components/wombat-ui";
import useViewer from "../hooks/useViewer";
import useTranslations from "../hooks/useTranslations";

type EditUserScreenProps = RouteComponentProps<{ id: string }>;

const EditUserScreen: React.FC<EditUserScreenProps> = ({ match }) => {
  const t = useTranslations();
  const { isCapableOfInsertingUsers } = useViewer();
  const { data, loading } = useGetUser({
    variables: { id: match.params.id },
  });

  const user = data?.user;

  return (
    <ScreenContainer
      loading={loading}
      error={
        !user?.canInsert ? (
          <EmptyState
            title={t("network.unauthorized") as string}
            action={
              <Link variant="button" to="/">
                {t("network.backToHome")}
              </Link>
            }
          />
        ) : undefined
      }
    >
      {user && (
        <UserFormScreen
          defaultValues={{
            id: user.id,
            email: user.email,
            name: user.name,
            locale: user.locale,
            role: user.role,
            avatar: {
              filename: "",
              data: user?.avatar || "",
            },
          }}
        />
      )}
    </ScreenContainer>
  );
};

export default React.memo(EditUserScreen);
